import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { roofApproachSchema } from "../../components/common/validations/Validation";
import TextField from "../../components/common/formInput/TextField";
import { options, message } from "../../components/common/utils/message";
import { alert, confirm } from "react-bootstrap-confirmation";
import { useLocation, useNavigate } from "react-router-dom";
import { failed, success } from "../../components/common/Toastify";
import queryString from 'query-string';
import { useDispatch } from "react-redux";
import TextArea from "../../components/common/formInput/TextArea";
import { addRoofApproach, listRoofApproach, updateRoofApproach } from "../../services/roofApproach";

const RoofApproachForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [resPayload, setResPayload] = useState();

    useEffect(() => {
        listRoofApproach({ page: 1 }, (data) => { setResPayload(data) }, dispatch);
    }, []);

    const roof_approach_id = queryString.parse(location.search)
    const get_roof_approach = resPayload && resPayload.docs.find((item) => item._id === roof_approach_id.id)

    const initialData = {
        _id: get_roof_approach ? get_roof_approach._id : "",
        name: get_roof_approach ? get_roof_approach.name : "",
        price: get_roof_approach ? get_roof_approach.price : "",
        description: get_roof_approach ? get_roof_approach.description : "",
    };

    /**
     * @description Function is for add New Roof Type.
     * @param {object} data 
     */
    const _submitData = (data) => {
        try {
            addRoofApproach(data, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message)
                    navigate("/roof-approach-list")
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };

    /**
     * @description Function is for Update New Roof Type
     * @param {object} data 
     */
    const _updateData = async (data) => {
        try {
            updateRoofApproach(data, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message);
                    navigate("/roof-approach-list")
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };

    /**
     * @description Function is For on Cancel Confirm Box.
     */
    const onCancel = async () => {
        const result = await confirm(message.cancelRoofApproach, options);
        if (result) {
            alert(message.canceledRoofApproach);
            navigate("/roof-approach-list");
        }
    };

    return (
        <div className="dashboard-inner p-b-0">
            <Formik
                initialValues={initialData}
                enableReinitialize
                validationSchema={roofApproachSchema}
                onSubmit={(values) => get_roof_approach ? _updateData(values) : _submitData(values)}
            >
                {(formik) => (
                    <Form>
                        <div className="d-card m-b-25">
                            <div className="d-card-header">
                                <h5 className="d-card-heading">Add Roof System Approach Managment</h5>
                            </div>
                            <div className="d-card-body p-b-0">
                                <div className="form-content">
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <TextField
                                                label="Roof Approach Name"
                                                name="name"
                                                value={formik?.values?.name}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <TextField
                                                label="Price Per Sq Ft"
                                                name="price"
                                                value={formik?.values?.price}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="f-row alignTop">
                                        <div className="f-66">
                                            <TextArea
                                                label="Roof Description"
                                                name="description"
                                                value={formik?.values?.description}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-card-bottom">
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-blue" type="submit">{get_roof_approach ? "Edit Roof Approach Managment" : "Add Roof Approach Managment"}</button>
                            </div>
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-grey" onClick={onCancel} type="button">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default RoofApproachForm;
